export default "__VITE_ASSET__237ba07d__"